<template>
  <div v-if="brains" class="user_container">
    <div class="user_block-wrapper header">
      <h2 class="user_title">Collect User Details</h2>
      <p class="user_description">
        Choose whether or not you want to collect the user details.
      </p>
    </div>
    <div class="user_block-wrapper">
      <ul class="user-radio-list">
        <li class="user-radio-list__item" v-for="item of collectOptions">
          <CustomRadio 
            :value="item?.value"
            :descriptionText="item?.description"
            :handleChange="handleChange"
            name="userData"
            :id="item?.id"
            customClass="radio_border"
            customClass_flex="radio_flex"
            customClass_header="radio_title"
            customClass_desc="radio_desc"
            :checked="brains?.users?.userData === item?.id"
          />
        </li>
      </ul>
    </div>
    <div class="user_block-wrapper header">
      <p class="user_title">Data Types</p>
      <div class="user_description">
        Choose what information you want to collect from visitors.
      </div>
      <ul class="checkbox-list">
        <li class="checkbox-list_item" v-for="item of dataTypes">
          <CustomCheckbox
            :disabled="disabledCheckboxes"
            :error="typesError"
            name="dataTypes"
            :item="item"
            :checked="brains?.users?.dataTypes?.includes(item)"
            :onChange="handleChange"
          />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import CustomCheckbox from "../../components/shared/UI/CustomCheckbox.vue";
import CustomRadio from "../../components/shared/UI/CustomRadio.vue";
import ButtonWithLoadWebsite from "../../components/shared/ButtonWithLoadWebsite.vue";

export default {
  props: {
    brains: Object,
    getChanges: Function
  },
  components: {
    CustomRadio,
    ButtonWithLoadWebsite,
    CustomCheckbox
  },
  data() {
    return {
      dataTypes: ['name', 'email', 'phone'],
      collectOptions: [
        {
          value: 'Mandatory',
          id: 'mandatory',
          description: 'User has to enter their details before they can continue the conversation'
        },
        {
          value: 'Optional',
          id: 'optional',
          description: 'We try to collect user details, but user should still be able to continue chatting by skipping the user details forms'
        },
        {
          value: 'Do Not Collect',
          id: 'none',
          description: 'We will not collect any user details'
        }
      ]
    }
  },
  computed: {
    typesError() {
      return this.brains?.users?.userData !== 'none' && this.brains?.users?.dataTypes.length === 0;
    },
    disabledCheckboxes() {
      return this.brains?.users?.userData === 'none';
    }
  },
  methods: {
    handleChange(e) {
      const {name, value, id} = e.target;

      if (name === 'userData') {
        this.getChanges('users', {...this.brains?.users, [name]: id}); 
      } else {
        if (this.brains?.users?.dataTypes.includes(value)) {
          this.getChanges('users', {...this.brains?.users, dataTypes: this.brains?.users?.dataTypes?.filter(item => item !== value)})
        } else {
          this.getChanges('users', {...this.brains?.users, dataTypes: [...this.brains?.users?.dataTypes, value]})
        }
      }
    },
  },
};
</script>

<style lang="scss">
.user_title {
  color: #333;
  font-family: "Inter", sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
}
.user_description {
  color: #bdbdbd;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}
.user_block-wrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;

  &.header {
    gap: 8px;
  }
}

.user_block-title {
  color: #333;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
}

.user-radio-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 440px;
}

.radio_flex {
  display: flex;
  flex-direction: column;
}

.radio_border {
  justify-content: start !important;
  border-radius: 10px !important;
  border: 1px solid #d1d1d6;
  background: #fff !important;
  width: 100% !important;
  transition: all 150ms linear;

  &:focus-visible,
    &:hover {
        border-color: rgb(49, 130, 206);
        box-shadow: rgb(49, 130, 206) 0px 0px 0px 1px;
    }
}
.radio_title {
  color: #1d1f20;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.radio_desc {
  color: #828282;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.checkbox-list {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}

.checkbox-list_item {
  list-style-type: none;
}
</style>
